import React from "react";
import PropTypes from 'prop-types';
import Download from '../../elements/icons/Download';
import Loading from "../../elements/icons/Loading";
import Settings from "../../elements/icons/Settings";
import {
    SUBSCRIPTION_STATE_CUSTOMER_PORTAL, SUBSCRIPTION_STATE_NOT_ACTIVE,
    SUBSCRIPTION_STATE_TRIAL_AVAILABLE,
    SUBSCRIPTION_STATE_TRIAL_USED
} from "../../../selectors/subscription";
import {downloadNowButton} from "../../../constants/classes/features";
import { withRouter } from 'react-router-dom';
import {freeTrialLink} from "../../../config/app";
import {getLandingSubscriptionButtonLink} from "../../../helpers/subscription";

class DownloadNowButton extends React.PureComponent {
    getButtonText = () => {
        const { subscriptionState } = this.props;

        switch (subscriptionState) {
            case SUBSCRIPTION_STATE_TRIAL_AVAILABLE:
                return 'Start Trial';
            case SUBSCRIPTION_STATE_TRIAL_USED:
            case SUBSCRIPTION_STATE_NOT_ACTIVE:
                return 'Subscribe';
            case SUBSCRIPTION_STATE_CUSTOMER_PORTAL:
            default:
                return 'Open dashboard';
        }
    }

    getIcon = () => {
        const { subscriptionState } = this.props;

        if (this.getIsLoading()) {
            return <Loading/>;
        }

        switch (subscriptionState) {
            case SUBSCRIPTION_STATE_TRIAL_AVAILABLE:
            case SUBSCRIPTION_STATE_TRIAL_USED:
            case SUBSCRIPTION_STATE_NOT_ACTIVE:
                return <Download/>;
            case SUBSCRIPTION_STATE_CUSTOMER_PORTAL:
            default:
                return <Settings/>;
        }
    }
    getIsLoading = () => {
        const { isPaymentResultPending, isPortalPending } = this.props;

        return isPaymentResultPending || isPortalPending;
    }
    clickHandler = () => {
        const { subscriptionState, history } = this.props;

        if (this.getIsLoading()) {
            return false;
        }

        return history.push(getLandingSubscriptionButtonLink(subscriptionState));
    }
    render() {
        const { isButtonLabel, monthPlan } = this.props;

        return (
            <div onClick={this.clickHandler} className={'download-now-button'}>
                <div className={'rounded-link'}>
                    <span>
                        {this.getIcon()}
                    </span>
                </div>

                <div className={'link-texts'}>
                    <div>
                        <div className={`${downloadNowButton} title`}>{this.getButtonText()}</div>
                    </div>

                    {isButtonLabel ? <div className={'label'}>
                        {monthPlan.trial_duration}-day free trial then ${monthPlan.price} monthly
                    </div> : false}
                </div>
            </div>
        );
    }
}

export default withRouter(DownloadNowButton);

DownloadNowButton.propTypes = {
    monthPlan: PropTypes.object.isRequired,
    isButtonLabel: PropTypes.bool,
    isPortalPending: PropTypes.bool.isRequired,
    isPaymentResultPending: PropTypes.bool.isRequired,
    subscriptionState: PropTypes.string,
};
